import utils from '~/utils';

export const getReferralsItem = data => {
    return {
        name: [
            data.user.last_name,
            data.user.first_name,
        ].filter(x => !!x).join(' '),
        status: data.first_investment_amount > 0 ? 'invested' : data.user.status,
        investment: data.investment_amount,
        investmentFormatted: `${utils.formats.formatNumberWithSpaces(data.investment_amount)} ₽`,
        fee: data.payout_amount,
        feeFormatted: data.has_subsequent_investments_commission_rate
            ? `${utils.formats.formatNumberWithSpaces(data.payout_amount)} ₽ (${Number(data.first_investment_commission_percent)}%)`
            : `${utils.formats.formatNumberWithSpaces(data.payout_amount)} ₽`,
        paymentStatus: data.payment_status,
        isPaid: data.payment_status === 'paid',
        hasSecondCommission: data.has_subsequent_investments_commission_rate,
        investments: Array.isArray(data.investments)
            ? data.investments.map((item, index) => {
                return {
                    id: item.id,
                    index: index + 1,
                    investment: item.amount,
                    investmentFormatted: `${utils.formats.formatNumberWithSpaces(item.amount)} ₽`,
                    commission: item.commission_amount,
                    commissionFormatted: `${utils.formats.formatNumberWithSpaces(item.commission_amount)} ₽`,
                    commissionPercent: item.commission_percent,
                    commissionPercentFormatted: `${Number(item.commission_percent)}%`,
                };
            })
            : [],
    };
};

export const getReferrals = data => {
    return data.results.map(getReferralsItem);
};
